import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';

import CurrencySign from 'components/price/CurrencySign.component';
import DELAY from 'constants/delay.const';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import { selectCheckoutBookingData } from 'selectors/checkout.selectors';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import fromAnyToCoinNum from 'utils/converters/any/fromAnyToCoinNum.util';
import fromAnyToLowerCase from 'utils/converters/any/fromAnyToLowerCase.util';
import { fromEventToValue } from 'utils/converters/event.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import delayed from 'utils/functions/delayed.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import asInput from 'utils/strings/asInput.util';

import {
  changeProductDiscountType,
  updateProductDiscount,
  updateProductPrice,
  updateProductQuantity,
  updateProductStylistId,
  updateProductTitle,
} from 'checkout/actions';
import DropdownSearch from 'checkout/components/DropdownSearch.component';

const L = logger('CheckoutProduct');

const INPUT_AMOUNT_PLACEHOLDER = '0.00';

class CheckoutProduct extends React.Component {
  constructor(props) {
    super(props);
    let { product } = this.props;
    if (!props.product.id) {
      product = {
        title: props.product.title || '',
        price: props.product.price,
      };
    } else if (product.title === '') {
      const productFromList = props.products.find((p) => p.id === props.product.id);
      if (productFromList) {
        product = productFromList;
      }
    }

    this.state = {
      product,
      editStylistModal: false,
      price: product.price ? product.price.toString() : '',
      displayMobile: true,
      searchQuery: '',
      oldSearchQuery: '',
      isDropdownOpen: false,
      isSearchQueryDirty: false,
      isSearchBlurred: false,
      discountType: 'absolute',
    };
  }

  componentDidMount() {
    this.props.updateProductPrice(this.props.clientIndex, this.props.index, parseFloat(this.state.product.price));
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    const oldStylists = this.props.stylists;
    // oldStylistId = this.props.stylists.find(c => c.id === this.props.product.stylistId);
    const oldStylistId = asObject(this.props.product).stylistId;

    const newStylists = nextProps.stylists;
    const newStylistId = asObject(nextProps.product).stylistId;

    const oldSelectedStylist = oldStylists.find(({ id }) => id === oldStylistId);
    const newSelectedStylist = newStylists.find(({ id }) => id === newStylistId);

    const newSearchQuery = asObject(newSelectedStylist).user_name;
    const oldSearchQuery = asObject(oldSelectedStylist).user_name;
    const isDirty = this.state.isSearchQueryDirty;

    if (!isDirty || newSearchQuery !== oldSearchQuery) {
      this.setState({ searchQuery: newSearchQuery, isSearchQueryDirty: false });
    }
  }

  onPriceChange = (price) => {
    let setPrice = price;
    if (price === '') {
      setPrice = '0';
    }
    if (this.isNaN(setPrice)) {
      return;
    }

    this.setState({ price: setPrice });
    this.props.updateProductPrice(this.props.clientIndex, this.props.index, setPrice);
  };
  onQuantityChange = (value) => {
    this.props.updateProductQuantity(this.props.clientIndex, this.props.index, parseFloat(value));
  };

  onStylistSelect = (stylistId, stylistName) => {
    if (stylistId) {
      this.props.updateProductStylistId(this.props.clientIndex, this.props.index, stylistId);
      this.setState({
        searchQuery: stylistName,
        isDropdownOpen: false,
        isSearchBlurred: false,
      });
    }
  };

  onSearchStylist = (event) =>
    void this.setState({
      searchQuery: fromAnyToString(getAnyOrVoid('target.value', event)),
      isSearchQueryDirty: true,
      isDropdownOpen: true,
    });

  onClickSearchStylist = () => {
    const isOpen = !this.state.isDropdownOpen;

    void this.setState({
      searchQuery: '',
      oldSearchQuery: this.state.searchQuery,
      isSearchQueryDirty: true,
      isSearchBlurred: isOpen,
      isDropdownOpen: isOpen,
    });
  };

  onDropdownClickOutside = () => {
    delayed(DELAY.fast, () => {
      if (this.state.isSearchBlurred) {
        this.setState({
          isDropdownOpen: false,
          isSearchBlurred: false,
          searchQuery: this.state.oldSearchQuery,
        });
      }
    });
  };

  toggleMoneyPercents = () => {
    const newType = this.props.product.discountType === 'absolute' ? 'percentage' : 'absolute';
    this.setState({ discountType: newType });
    this.props.changeProductDiscountType(this.props.clientIndex, this.props.index, newType);
  };

  discountUpdate = (ev) => {
    const { updateProductDiscount, clientIndex, index } = this.props;
    const { discountType, price: priceFromState } = this.state;

    const value = fromEventToValue(ev);
    const discount = fromAnyToCoinNum(value || '0');
    const price = fromAnyToCoinNum(priceFromState);

    if (Number.isNaN(discount)) {
      L.warn('discountUpdate()', 'Invalid discount:', discount, 'because value:', value);
      return;
    }

    if (Number.isNaN(price)) {
      L.warn('discountUpdate()', 'Invalid price:', price, 'because priceFromState:', priceFromState);
    }

    if (discountType === 'percentage' && discount > 100) {
      updateProductDiscount(clientIndex, index, 100);
      return;
    }

    if (discountType !== 'percentage' && discount > price) {
      updateProductDiscount(clientIndex, index, price);
      return;
    }

    updateProductDiscount(clientIndex, index, discount);
  };

  nameChangeHandler = (event) => {
    this.props.updateProductTitle(this.props.clientIndex, this.props.index, event.target.value);
  };
  toggleStylistEdit = () => {
    this.setState({ editStylistModal: !this.state.editStylistModal });
  };
  showRow = () => {
    this.setState({ displayMobile: !this.state.displayMobile });
  };
  isNaN = (value) => {
    const n = Number(value);
    // eslint-disable-next-line no-self-compare
    return n !== n;
  };

  render() {
    const { t } = this.props;
    const { searchQuery, isDropdownOpen } = this.state;
    const moneyClassName = classNames('chk-tog-btn chk-cash-btn', {
      'chk-selected': this.props.product.discountType === 'absolute',
    });
    const percentageClassName = classNames('chk-tog-btn chk-percent-btn', {
      'chk-selected': this.props.product.discountType === 'percentage',
    });

    const searchString = fromAnyToLowerCase(searchQuery);
    const renderedStylists = this.props.stylists
      .filter(
        (s) =>
          s.status !== 'deleted' &&
          s.has_column &&
          (searchQuery === '' || fromAnyToLowerCase(s.user_name).includes(searchString)),
      )
      .map((stylist) => (
        <li
          tabIndex={0}
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
          role="button"
          onClick={() => this.onStylistSelect(stylist.id, stylist.user_name)}
          key={stylist.id}
        >
          {stylist.user_name}
        </li>
      ));

    const calcFinalPrice = this.props.product.finalPrice;

    return (
      <div className="table-checkout body">
        <div className="tbody">
          <div className="tr">
            <div className="cell-product of-product">
              {this.props.product.title && <span>{this.state.product.title}</span>}
            </div>
            <div className={this.state.displayMobile ? 'cell-quantity hide' : 'cell-quantity'}>
              <span className="v-in-mobile">{t('checkout.checkoutClient.quantity')}</span>
              <input
                type="text"
                className="input-quantity"
                value={this.props.product.quantity ? this.props.product.quantity : ''}
                placeholder=" "
                onChange={(e) => {
                  this.onQuantityChange(e.target.value);
                }}
              />
            </div>
            <div className={this.state.displayMobile ? 'cell-staff hide relative' : 'cell-staff'}>
              <span className="v-in-mobile" style={{ marginTop: '7px' }}>
                {t('checkout.checkoutClient.staffMember')}
              </span>
              <DropdownSearch
                placeholder={t('checkout.checkoutClient.dropdownSearchPlaceholder')}
                type="text"
                isOpen={isDropdownOpen}
                value={searchQuery}
                stylistList={renderedStylists && renderedStylists}
                onChange={this.onSearchStylist}
                onClick={this.onClickSearchStylist}
                onBlur={this.onDropdownClickOutside}
              />
            </div>
            <div className="cell-price">
              <div className="product-discount">
                {!this.state.product.id && (
                  <input
                    type="text"
                    className="chk-amount-input"
                    placeholder={INPUT_AMOUNT_PLACEHOLDER}
                    value={this.props.product.price ? this.props.product.price : ''}
                    onChange={(e) => {
                      this.onPriceChange(e.target.value);
                    }}
                    autoComplete="off"
                  />
                )}
                {this.state.product.id && (
                  <div className="product-discount">
                    <CurrencySign />
                    <input
                      type="text"
                      className="chk-popup-col3-input"
                      placeholder={INPUT_AMOUNT_PLACEHOLDER}
                      value={this.state.price}
                      onChange={(e) => this.onPriceChange(e.target.value)}
                      onBlur={() => {}}
                      autoComplete="off"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className={this.state.displayMobile ? 'cell-discount hide' : 'cell-discount'}>
              <span className="v-in-mobile">{t('checkout.checkoutClient.discount')}</span>
              <div className="discount">
                <input
                  type="text"
                  className="chk-amount-input"
                  placeholder={INPUT_AMOUNT_PLACEHOLDER}
                  value={asInput(this.props.product.discount)}
                  onChange={this.discountUpdate}
                  autoComplete="off"
                />
                <button
                  className={moneyClassName}
                  onClick={() => (this.props.product.discountType === 'absolute' ? null : this.toggleMoneyPercents())}
                >
                  <CurrencySign />
                </button>
                <button
                  className={percentageClassName}
                  onClick={() => (this.props.product.discountType === 'percentage' ? null : this.toggleMoneyPercents())}
                >
                  {S.percent}
                </button>
              </div>
            </div>
            <div className={this.state.displayMobile ? 'cell-total hide' : 'cell-total'}>
              <span className="v-in-mobile">{t('checkout.checkoutClient.total')}</span>
              <div className="total">
                <CurrencySign />
                {calcFinalPrice}
              </div>
            </div>
            <div className="cell-last">
              <div className="v-in-mobile btn-show-options" role="button" tabIndex={0} onClick={this.showRow}>
                {this.state.displayMobile ? t('checkout.checkoutClient.optionsButton') : t('common.buttons.done')}
              </div>
              <button className="btn-remove-product" onClick={() => this.props.onDelete(this.props.index)}>
                {t('common.buttons.removeUpp')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  bookingData: selectCheckoutBookingData(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProductDiscountType,
      updateProductTitle,
      updateProductPrice,
      updateProductDiscount,
      updateProductStylistId,
      updateProductQuantity,
    },
    dispatch,
  );

// this extra export is needed for tests that provide their own mock for connect()
export { CheckoutProduct as CheckoutProduct4Test };

const CheckoutProductHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CheckoutProduct));

export default CheckoutProductHoc;
